import { Api } from '@/store/api';
import { Client, globalRegions } from 'altru-types';
import { Credentials } from '@/store/auth/types';

export async function getWorkspace(workspaceId: string, payload: string): Promise<Client> {
  const response = await Api.get(`/api/us/clients/${workspaceId}?payload=${payload}`);
  return response.data.data;
}

export async function getWorkspaceWithCredentials(
  workspaceId: string,
  authHeaders: Credentials,
  region: globalRegions,
): Promise<Client> {
  const response = await Api.get(`/api/${region}/clients/${workspaceId}`, {
    headers: authHeaders,
  });
  return response.data.data;
}
